import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';

function App() { return <LanguageProvider><AuthProvider><CartProvider><AppRoutes /></CartProvider></AuthProvider></LanguageProvider>; }

export default App;
